import Image from 'next/image'
import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { IconTrashDelete } from '@redteclab/icons'

export type AfterSalesImageControlImageThumbnailImage = {
  file: File
  previewUrl: string
}

export const AfterSalesImageControlImageThumbnail: FC<{
  handleRemoveImage: () => void
  image: AfterSalesImageControlImageThumbnailImage
}> = ({ handleRemoveImage, image }) => {
  const intl = useIntl()

  return (
    <div className="relative size-20 overflow-hidden rounded-s border border-dark-primary-strong">
      <Image
        alt={image.file.name}
        className="object-contain"
        fill
        src={image.previewUrl}
        unoptimized
      />
      <button
        aria-label={intl.formatMessage({
          id: 'uploadImage.thumbnail.deleteImage.ariaLabel',
        })}
        className="absolute -right-1 -top-1 flex size-10 items-center justify-center"
        onClick={handleRemoveImage}
        type="button"
      >
        <span className="rounded-full bg-light-brand-high p-1">
          <IconTrashDelete className="size-4" />
        </span>
      </button>
    </div>
  )
}
